import * as React from 'react';

import { Backdrop, Box, CircularProgress, IconButton, ListItem, ListItemText, Paper, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { alpha } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';

import { visuallyHidden } from '@mui/utils';
import { Archive, Download, Html, Lock, LockOpen, Menu, Schema, Upload, Visibility } from '@mui/icons-material';


import ConfirmDialog from '../../common/ConfirmDialog';
import Service from '../../../util/Service';
import SearchField from '../../util/SearchField';

export default function ArquivadasTable(props) {
    const { dadosRoot, kanban, setUpdateKanban } = props;
    const navigate = useNavigate();

    const [modalOpen, setModalOpen] = React.useState(false);
    const [wait, setWait] = React.useState(false);

    const [rows, setRows] = React.useState(dadosRoot);

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(true);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    React.useEffect(() => {
        if (dadosRoot) {
            setRows(dadosRoot);
        }
    }, [dadosRoot])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const visibleRows = React.useMemo(
        () =>
            [...rows]
                .sort(getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [order, orderBy, page, rowsPerPage, rows],
    );
    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }

    function handleClickDesarquivar() {
        console.log(selected);

        Service.POST("/api/security/projeto/kanban/desarquivar", selected).then( r =>{
            console.log( r );
            if( r.success ){
                setUpdateKanban(true);
                const dados = [];
                
                for( let r of rows){
                    const item = selected.find( s => s === r.id);
                    if( item ) continue;
                    dados.push(r);
                }
                
                setRows( dados );
            }
        })

    }
    function showCard(card) {
        return (
            <ListItem alignItems="flex-start">
                <ListItemText
                    primary={card.nome}
                    secondary={
                        <React.Fragment>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: 'text.primary', display: 'inline' }}
                            >
                                Concluido:
                            </Typography>
                            {" — "+ (card.concluido?"sim":"não")+(card.esforco?", com esforço de "+card.esforco+" horas":"")}
                        </React.Fragment>
                    }
                />
            </ListItem>

        )
    }
    function onSearch(txt) {
        console.log(txt);
        // if( !txt || txt.length === 0 ){
        //     setRows( dadosRoot );
        //     return;
        // }
        // const arr = dadosRoot.filter( t =>{
        //     if( t.nome.toUpperCase().indexOf(txt.toUpperCase())>= 0){
        //         return true;
        //     }
        //     if( t.titulo && t.titulo.indexOf(txt)>= 0){
        //         return true;
        //     }
        //     if( t.descricao && t.descricao.indexOf(txt)>= 0){
        //         return true;
        //     }

        //     return false;
        // });
        // setRows( arr);
    }


    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{
                width: '100%',
                mb: 2,
                // display:paperShow 
            }}
            >
                <EnhancedTableToolbar kanban={kanban}
                    numSelected={selected.length}
                    onSearch={onSearch}
                    action={handleClickDesarquivar}
                />

                <TableContainer>
                    <Table
                        sx={{ minWidth: 750, mt: 2 }}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {visibleRows.map((row, index) => {
                                const isItemSelected = selected.includes(row.id);
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <TableRow
                                        hover
                                        onClick={(event) => handleClick(event, row.id)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.id}
                                        selected={isItemSelected}
                                        sx={{ cursor: 'pointer' }}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                checked={isItemSelected}
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                            sx={{ width: '380px', minWidth: '100px', maxWidth: '400px' }}
                                        >
                                            {showCard(row.card)}
                                        </TableCell>
                                        <TableCell ><span style={{ fontSize: '0.8em' }}>{formataData(row.dtCriacao)}</span></TableCell>
                                        <TableCell align="center">{row.owner.nome}</TableCell>


                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: (dense ? 33 : 53) * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={wait}
                onClick={() => setWait(false)}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    )
}


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        id: 'card',
        numeric: false,
        disablePadding: true,
        label: 'Card',
    },
    {
        id: 'data',
        numeric: false,
        disablePadding: true,
        label: 'Data',
    },
    {
        id: 'owner',
        numeric: false,
        disablePadding: true,
        label: 'Quem Arquivou',
    }
];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead size='small'>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
function EnhancedTableToolbar(props) {
    const { numSelected, kanban, onSearch, action } = props;

    function handleDesarquivar() {
        console.log(numSelected);
        action();
    }
    return (
        <Toolbar variant="dense"
            sx={[
                {
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                },
                numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                },
            ]}
        >
            {numSelected > 0 ? (
                <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{
                        color: "inherit",
                        flex: '1 1 100%'
                    }}>
                    {numSelected} selecionada
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    {kanban.nome}
                </Typography>
            )}
            <SearchField handleSearch={onSearch} />
            <Tooltip title="Desarquivar" style={{marginLeft:'10px'}}>
                <IconButton aria-label="comment" onClick={handleDesarquivar}>
                    <Archive />
                </IconButton>
            </Tooltip>
        </Toolbar>
    );
}